<style>
.holder {
    margin-top: 5px;
}


.tag-box {
    padding: 5px;
    padding-right: 10px;
    border-radius: 10px;
    display: inline-block;
    color: white;
    margin: 5px;
    margin-left: 0px;
    margin-top: 0px;
    cursor: pointer;
    font-size: 12px;
}

.tag-box:hover {
    background-color: black;
}

.remove-x {
    font-size: 12px;
    padding-right: 10px;
    padding-left: 5px;
}

.selected {
    background-color: grey;
}

.suggested {
    background-color: lightgrey;
    color: grey;
}
</style>

<script>
    import * as Common from './Common.js'

    export let selectedTags = []
    export let suggestedTags = []

    let newTagText = ""

    function addNewTag(e) {        
        if(e.key != 'Enter') {
            return
        }
        if(newTagText.length === 0) {
            return
        }

        selectedTags = selectedTags.concat(newTagText);
        newTagText = ""
    }

    function isTagValid(tag) {
        return tag.match(/^[0-9a-zA-Z_]+$/)
    }

    function addNewTagClick(e) {
         if(newTagText.length === 0) {
            return
        }

        if(!isTagValid(newTagText)) {
            alert("Tag can only contain letters, numbers and underscores.")
            return
        }

        if(selectedTags.find(e => e===newTagText) != undefined) {
            return
        }

        selectedTags = selectedTags.concat(newTagText);
        newTagText = ""
    }

    function removeSelectedTag(selectedTag) {
        selectedTags = selectedTags.filter(t => t !== selectedTag)
    }

    let requestPending = false
    function tagSearchChange(e) {
        if(e.key == 'Enter') {
            return
        }

        if(newTagText.length==0 || requestPending) {
            return
        }
        requestPending = true
        suggestedTags = null

        setTimeout(() => {
            if(newTagText.length==0) {
                requestPending = false
                return
            }

            Common.getData('tags-search/' + newTagText)
            .then(data => {
                suggestedTags = data.filter(t => selectedTags.find(e => e==t) === undefined)
            })
            requestPending = false
        }, 1000)
    }

    function addThisTag(tag) {
        selectedTags = selectedTags.concat(tag);
        newTagText = ""
    }
</script>

<div class="holder">
    <div class="tags-holder">
        {#each selectedTags as selectedTag}
            <div class="tag-box selected" on:click={() => removeSelectedTag(selectedTag)}>
                 <span class="remove-x">x</span># {selectedTag}
            </div>
        {/each}
         {#if newTagText.length != 0}
            <div class="tag-box suggested" on:click={addNewTagClick}>
                 <span class="remove-x">+</span># {newTagText}
            </div>
            {#if suggestedTags && suggestedTags.length != 0}
                {#each suggestedTags as tag}
                    <div class="tag-box suggested" on:click={() => addThisTag(tag)}>
                        <span class="remove-x">+</span># {tag}
                    </div>
                {/each}
            {/if}
        {/if}
    </div>
    <div class="addbox-holder">
        <input type="text" bind:value={newTagText} placeholder="Type New Tag" on:keypress={addNewTag} on:input={tagSearchChange}>
    </div>
</div>